import {useEffect,useRef,useState} from 'react';
import {Download,Play} from 'lucide-react';
import '../../styles/control-helper.css';

export const HELPER_DOWNLOAD='/downloads/SkrepkaHelper-0f5faecf096d2a93.exe';
const KEY='skrepka-helper-installed-v2';
export function helperStatus(focus=false):Promise<boolean>{
  return new Promise(resolve=>{
    let ws:WebSocket|undefined,done=false;
    const finish=(installed:boolean)=>{if(done)return;done=true;clearTimeout(timer);ws?.close();resolve(installed);};
    const timer=setTimeout(()=>finish(false),1800);
    try{ws=new WebSocket('ws://127.0.0.1:17843/status');
      ws.onmessage=e=>{try{const p=JSON.parse(String(e.data)) as {type?:string;protocol?:number;installed?:boolean};if(p.type==='helper-status'&&p.protocol===2&&p.installed===true){if(focus)ws?.send(JSON.stringify({type:'focus'}));finish(true);}else finish(false);}catch{finish(false);}};
      ws.onerror=()=>finish(false);ws.onclose=()=>finish(false);
    }catch{finish(false);}
  });
}
function remembered(){try{return localStorage.getItem(KEY)==='2';}catch{return false;}}
function remember(installed:boolean){try{if(installed)localStorage.setItem(KEY,'2');else localStorage.removeItem(KEY);}catch{/* Storage can be disabled. */}}
export function HelperActions(){
  const [installed,setInstalled]=useState(remembered),[launching,setLaunching]=useState(false),[notice,setNotice]=useState('');
  const alive=useRef(true),attempt=useRef(0);
  useEffect(()=>{alive.current=true;const check=()=>{void helperStatus().then(ok=>{if(ok&&alive.current){remember(true);setInstalled(true);setNotice('Помощник установлен');}});};check();window.addEventListener('focus',check);return()=>{alive.current=false;window.removeEventListener('focus',check);};},[]);
  const launch=async()=>{
    const id=++attempt.current;setLaunching(true);setNotice('Открываем помощник…');
    let found=await helperStatus(true);
    if(!alive.current||id!==attempt.current)return;
    if(!found){window.location.href='skrepka-helper://launch';
      const until=Date.now()+20000;
      while(alive.current&&id===attempt.current&&Date.now()<until){await new Promise(r=>setTimeout(r,700));found=await helperStatus(true);if(found)break;}
    }
    if(!alive.current||id!==attempt.current)return;
    remember(found);setInstalled(found);setLaunching(false);setNotice(found?'Помощник открыт. Код подключения — в его окне.':'Не удалось открыть помощник. Установите его или разрешите браузеру открывать приложение Скрепки и подключаться к локальному устройству.');
  };
  return <div className="helper-actions"><div className="helper-actions-buttons">
    {installed?<button disabled title="Помощник уже установлен на этом компьютере"><Download size={18}/>Установлен</button>:<a href={HELPER_DOWNLOAD} download="Помощник Скрепки.exe" onClick={()=>setNotice('Откройте скачанный файл один раз. Он установит помощник; дальше используйте «Запустить».')}><Download size={18}/>Установить</a>}
    <button type="button" disabled={launching} onClick={()=>void launch()}><Play size={18}/>{launching?'Открываем…':'Запустить'}</button></div>
    {notice&&<small role="status">{notice}</small>}
  </div>;
}
